function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { processFeatureProperties } from './util/props';
import { WFS_ID_KEY, WFS_FTR_ID_KEY } from '../../../mapmodule/domain/constants';
import { getFilterAlternativesAsArray, filterFeaturesByAttribute } from '../../../mapmodule/util/vectorfeatures/filter';
var getFeatureId = function getFeatureId(feature) {
  return feature.id || feature.properties[WFS_ID_KEY] || feature.properties[WFS_FTR_ID_KEY];
};
export var ReqEventHandler = /*#__PURE__*/function () {
  function ReqEventHandler(sandbox) {
    _classCallCheck(this, ReqEventHandler);
    this.sandbox = sandbox;
    this.isClickResponsive = true;
  }
  return _createClass(ReqEventHandler, [{
    key: "createEventHandlers",
    value: function createEventHandlers(plugin) {
      var _this = this;
      var me = this;
      var getSelectedLayer = function getSelectedLayer(layerId) {
        return _this.sandbox.getMap().getSelectedLayer(layerId);
      };
      var getSelectionService = function getSelectionService() {
        return _this.sandbox.getService('Oskari.mapframework.service.VectorFeatureSelectionService');
      };
      return {
        MapClickedEvent: function MapClickedEvent(event) {
          if (!me.isClickResponsive) {
            return;
          }
          var hits = plugin.getMapModule().getFeaturesAtPixel(event.getMouseX(), event.getMouseY(), event.isTouchEvent());
          var keepPrevious = event.getParams().ctrlKeyDown;
          var modifySelectionOpts = {};
          var getSelectionOptsForLayer = function getSelectionOptsForLayer(layer) {
            var selectionOpts = modifySelectionOpts[layer.getId()];
            if (!selectionOpts) {
              selectionOpts = {
                layer: layer,
                features: []
              };
              modifySelectionOpts[layer.getId()] = selectionOpts;
            }
            return selectionOpts;
          };
          hits.forEach(function (_ref) {
            var featureProperties = _ref.featureProperties,
              layerId = _ref.layerId,
              feature = _ref.feature;
            var layer = getSelectedLayer(layerId);
            if (!layer || !plugin.isLayerSupported(layer)) {
              return;
            }
            if (keepPrevious) {
              getSelectionOptsForLayer(layer).features.push(feature);
            } else {
              plugin.notify('GetInfoResultEvent', {
                layerId: layerId,
                features: [processFeatureProperties(featureProperties, true)],
                lonlat: event.getLonLat()
              });
            }
          });
          if (keepPrevious) {
            var service = getSelectionService();
            if (service) {
              Object.keys(modifySelectionOpts).forEach(function (layerId) {
                modifySelectionOpts[layerId].features.map(function (feat) {
                  return feat.getId();
                }).forEach(function (featureId) {
                  return service.toggleFeatureSelection(layerId, featureId);
                });
              });
            }
          }
        },
        WFSSetFilter: function WFSSetFilter(event) {
          var service = getSelectionService();
          if (!service) {
            return;
          }
          var keepPrevious = Oskari.ctrlKeyDown();
          var featureCollection = event.getGeoJson();
          var filterFeature = featureCollection.features[0];
          if (['Polygon', 'MultiPolygon'].indexOf(filterFeature.geometry.type) >= 0 && typeof filterFeature.properties.area !== 'number') {
            return;
          }
          var targetLayers;
          if (event.selectFromAllLayers()) {
            targetLayers = plugin.getAllLayerIds();
          } else {
            var layerId = plugin.WFSLayerService.getTopWFSLayer();
            targetLayers = layerId ? [layerId] : [];
          }
          var featuresResult = plugin.getFeatures({
            geometry: filterFeature.geometry
          }, {
            layers: targetLayers
          });
          Object.keys(featuresResult).forEach(function (layerId) {
            var layerFeatures = featuresResult[layerId].features || [];
            var selectedFeatureIds = layerFeatures.map(getFeatureId);
            if (keepPrevious) {
              selectedFeatureIds.forEach(function (id) {
                return service.addSelectedFeature(layerId, id);
              });
            } else {
              service.setSelectedFeatureIds(layerId, selectedFeatureIds);
            }
          });
        },
        WFSSetPropertyFilter: function WFSSetPropertyFilter(event) {
          if (!event.getFilters() || event.getFilters().filters.length === 0) {
            return;
          }
          var service = getSelectionService();
          if (!service) {
            return;
          }
          var layerId = event.getLayerId();
          var featuresResult = plugin.getFeatures(null, {
            layers: [layerId]
          });
          var records = featuresResult[layerId].features || [];
          if (!records.length) {
            return;
          }
          var filteredIds = new Set();
          // filters is an object with key "filters" that we actually want to process...
          var _event$getFilters = event.getFilters(),
            _event$getFilters$fil = _event$getFilters.filters,
            filters = _event$getFilters$fil === void 0 ? [] : _event$getFilters$fil;
          var alternatives = getFilterAlternativesAsArray(filters);
          alternatives.forEach(function (attributeFilters) {
            var filteredList = records;
            attributeFilters.forEach(function (filter) {
              filteredList = filterFeaturesByAttribute(filteredList, filter);
            });
            filteredList.map(getFeatureId).filter(function (id) {
              return !!id;
            }).forEach(function (id) {
              return filteredIds.add(id);
            });
          });
          service.setSelectedFeatureIds(layerId, _toConsumableArray(filteredIds));
        }
      };
    }
  }, {
    key: "createRequestHandlers",
    value: function createRequestHandlers() {
      return {
        'WfsLayerPlugin.ActivateHighlightRequest': this
      };
    }

    // handle WfsLayerPlugin.ActivateHighlightRequest
  }, {
    key: "handleRequest",
    value: function handleRequest(oskariCore, request) {
      this.isClickResponsive = request.isEnabled();
    }
  }]);
}();